import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import { SxProps } from '@mui/material/styles';
import { mdiDotsVertical } from '@mdi/js';

import { DropdownMenu } from 'common/components/DropdownMenu';
import { IconButton } from 'common/components/IconButton';
import { Divider } from 'common/components/Divider';

export interface IMenuOption {
    label: string;
    onClick: () => void;
}

interface IProps {
    header: ReactNode;
    menuOptions?: IMenuOption[];
    children: ReactNode;
    sx?: SxProps;
}

export const ListPanel = ({ header, menuOptions, children, sx }: IProps) => (
    <Box
        sx={[
            {
                px: 2,
                pb: 0,
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 1,
            },
            ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        ]}
    >
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                py: 2,
            }}
        >
            <Box sx={{ flex: 1, minWidth: 0 }}>{header}</Box>

            {!!menuOptions?.length && (
                <DropdownMenu
                    anchor={
                        <IconButton
                            color="inherit"
                            iconPath={mdiDotsVertical}
                            iconSize="2.4rem"
                            sx={{ ml: 'auto' }}
                        />
                    }
                    placement="bottom-end"
                >
                    {menuOptions.map((option) => (
                        <MenuItem key={option.label} onClick={option.onClick}>
                            {option.label}
                        </MenuItem>
                    ))}
                </DropdownMenu>
            )}
        </Box>

        <Divider />

        {children}
    </Box>
);
